export const normalizeImportId = (importId) => {
    if (importId == null || importId === "") {
        return importId;
    }

    const normalized = String(importId).trim().toLowerCase();
    return normalized === "consolidated" ? "full" : importId;
};

export const isConsolidatedImportLabel = (importIdOrLabel) => {
    const normalized = String(importIdOrLabel || "").trim().toLowerCase();
    return normalized === "full" || normalized === "consolidated";
};

export const toNumericImportId = (importId) => {
    if (importId == null || importId === "" || isConsolidatedImportLabel(importId)) {
        return undefined;
    }
    if (typeof importId === "number" && Number.isInteger(importId) && importId > 0) {
        return importId;
    }
    const asString = String(importId).trim();
    if (!/^\d+$/.test(asString)) {
        return undefined;
    }
    const parsed = Number(asString);
    return parsed > 0 ? parsed : undefined;
};

export const formatImportIdDisplayLabel = (importIdOrLabel) => {
    if (isConsolidatedImportLabel(importIdOrLabel)) {
        return "Consolidated";
    }

    return String(importIdOrLabel || "").trim();
};

export const parseRawDataTableLabel = (tableLabel) => {
    if (!tableLabel || typeof tableLabel !== "string" || !tableLabel.includes(" - ")) {
        return null;
    }

    const [prefix, ...entityParts] = tableLabel.split(" - ");
    const trimmedPrefix = prefix?.trim();
    const entity = entityParts.join(" - ").trim();

    if (!trimmedPrefix || !entity) {
        return null;
    }

    const importId = normalizeImportId(trimmedPrefix);

    return {
        importId,
        entity,
        optionValue: `${importId} - ${entity}`,
        displayLabel: `${formatImportIdDisplayLabel(trimmedPrefix)} - ${entity}`,
    };
};

export const buildImportIdOptionFromTableLabel = (tableLabel) => {
    const parsed = parseRawDataTableLabel(tableLabel);
    if (!parsed) {
        return null;
    }

    return {
        id: parsed.importId,
        name: formatImportIdDisplayLabel(parsed.importId),
    };
};
